import type { StaffContractDetailModel } from '@urbanx/agx.campaigns.client'

export type ContractInformationStage = NonNullable<
  StaffContractDetailModel['contractStage']
>

export const CONTRACT_INFORMATION_UNLOCKED_STAGES: readonly ContractInformationStage[] =
  ['Accepted', 'Unconditional', 'Settled']

export function isContractInformationUnlocked(
  contractStage?: ContractInformationStage
): boolean {
  if (!contractStage) return false

  return CONTRACT_INFORMATION_UNLOCKED_STAGES.includes(contractStage)
}
